import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { UserUpdateComponent } from "./user-update.component";
import { SelectModule } from "ng2-select";

@NgModule({
    declarations: [
      UserUpdateComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule,
      SelectModule
    ],
    entryComponents: [
      UserUpdateComponent
    ]
})
export class UserUpdateModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/update/user-update.module.ts